import { post } from '@/request';

const newsApi = {
  list(data) {
    return post('/gt/news/zlb/list', data);
  },
  one(data) {
    return post('/gt/news/zlb/one', data);
  },
  listType(data) {
    return post('/gt/type/zlb/list', data);
  },
  oneType(data) {
    return post('/gt/type/zlb/one', data);
  }
};
export default newsApi;
